import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCondominio } from '../contexts/CondominioContext';
import { Settings, Save, RefreshCw } from 'lucide-react';
import LoadingSpinner from '../components/LoadingSpinner';
import { api } from '../services/api';

const ConfiguracoesGerais = () => {
  const { user } = useAuth();
  const { getCondominioId } = useCondominio();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [configuracoes, setConfiguracoes] = useState({
    sistema_nome: '',
    sistema_logo: '',
    sistema_versao: '',
    sistema_manutencao: false,
    sistema_manutencao_mensagem: '',
    email_smtp_host: '',
    email_smtp_port: '',
    email_smtp_user: '',
    email_smtp_pass: '',
    email_smtp_secure: false,
    backup_automatico: false,
    backup_frequencia: 'diario',
    backup_manter_dias: 30,
    seguranca_tentativas_login: 5,
    seguranca_tempo_bloqueio: 30,
    seguranca_senha_minima: 6,
    seguranca_senha_expiracao: 90
  });

  useEffect(() => {
    loadConfiguracoes();
  }, []);

  const loadConfiguracoes = async () => {
    try {
      setLoading(true);
      let sistemaVersao = '1.0.4';
      try {
        const response = await api.get('/versao/atual/web');
        if (response?.data?.success && response.data.data?.versao) {
          sistemaVersao = response.data.data.versao;
        }
      } catch (_e) {
        // mantém fallback
      }

      setConfiguracoes(prev => ({
        ...prev,
        sistema_nome: 'SindicoON',
        sistema_versao: sistemaVersao
      }));
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfiguracoes(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      // Aqui você pode implementar a API para salvar configurações
      console.log('Salvando configurações:', configuracoes);
      
      // Simular salvamento
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      alert('Configurações salvas com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar configurações:', error);
      alert('Erro ao salvar configurações');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center">
          <Settings className="h-6 w-6 mr-2" />
          Configurações Gerais
        </h1>
        <p className="text-gray-600 mt-1">
          Configure as opções gerais do sistema
        </p>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6">
          <form onSubmit={(e) => { e.preventDefault(); handleSave(); }} className="space-y-6">
            
            {/* Sistema */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Sistema</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nome do Sistema
                  </label>
                  <input
                    type="text"
                    name="sistema_nome"
                    value={configuracoes.sistema_nome}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Versão
                  </label>
                  <input
                    type="text"
                    name="sistema_versao"
                    value={configuracoes.sistema_versao}
                    readOnly
                    title="Atualizada automaticamente a cada commit"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-700"
                  />
                </div>
              </div>
              
              <div className="mt-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="sistema_manutencao"
                    checked={configuracoes.sistema_manutencao}
                    onChange={handleInputChange}
                    className="mr-2"
                  />
                  <span className="text-sm font-medium text-gray-700">
                    Modo de Manutenção
                  </span>
                </label>
                {configuracoes.sistema_manutencao && (
                  <div className="mt-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mensagem de Manutenção
                    </label>
                    <textarea
                      name="sistema_manutencao_mensagem"
                      value={configuracoes.sistema_manutencao_mensagem}
                      onChange={handleInputChange}
                      rows={3}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Digite a mensagem que será exibida durante a manutenção..."
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Email */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Email</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    SMTP Host
                  </label>
                  <input
                    type="text"
                    name="email_smtp_host"
                    value={configuracoes.email_smtp_host}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    SMTP Port
                  </label>
                  <input
                    type="number"
                    name="email_smtp_port"
                    value={configuracoes.email_smtp_port}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    SMTP Usuário
                  </label>
                  <input
                    type="text"
                    name="email_smtp_user"
                    value={configuracoes.email_smtp_user}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    SMTP Senha
                  </label>
                  <input
                    type="password"
                    name="email_smtp_pass"
                    value={configuracoes.email_smtp_pass}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="mt-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="email_smtp_secure"
                    checked={configuracoes.email_smtp_secure}
                    onChange={handleInputChange}
                    className="mr-2"
                  />
                  <span className="text-sm font-medium text-gray-700">
                    Usar SSL/TLS
                  </span>
                </label>
              </div>
            </div>

            {/* Backup */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Backup</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="backup_automatico"
                      checked={configuracoes.backup_automatico}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    <span className="text-sm font-medium text-gray-700">
                      Backup Automático
                    </span>
                  </label>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Frequência
                  </label>
                  <select
                    name="backup_frequencia"
                    value={configuracoes.backup_frequencia}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="diario">Diário</option>
                    <option value="semanal">Semanal</option>
                    <option value="mensal">Mensal</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Manter Backups (dias)
                  </label>
                  <input
                    type="number"
                    name="backup_manter_dias"
                    value={configuracoes.backup_manter_dias}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>

            {/* Segurança */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Segurança</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tentativas de Login
                  </label>
                  <input
                    type="number"
                    name="seguranca_tentativas_login"
                    value={configuracoes.seguranca_tentativas_login}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tempo de Bloqueio (minutos)
                  </label>
                  <input
                    type="number"
                    name="seguranca_tempo_bloqueio"
                    value={configuracoes.seguranca_tempo_bloqueio}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tamanho Mínimo da Senha
                  </label>
                  <input
                    type="number"
                    name="seguranca_senha_minima"
                    value={configuracoes.seguranca_senha_minima}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Expiração da Senha (dias)
                  </label>
                  <input
                    type="number"
                    name="seguranca_senha_expiracao"
                    value={configuracoes.seguranca_senha_expiracao}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>

            {/* Botões */}
            <div className="flex justify-end space-x-3 pt-6 border-t">
              <button
                type="button"
                onClick={loadConfiguracoes}
                className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 flex items-center"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Recarregar
              </button>
              <button
                type="submit"
                disabled={saving}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center"
              >
                <Save className="h-4 w-4 mr-2" />
                {saving ? 'Salvando...' : 'Salvar Configurações'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracoesGerais;



